import { Doc } from "../../../_generated/dataModel";
import { FilterRule, FilterRuleCtx } from "../../../lib/types/filters_types";

export const verificationStatusRule: FilterRule<Doc<"order_payments">> = {
  priority: 3,
  build: async (ctx, args) => {
    const { userContext, db } = ctx;

    if (
      !args.verificationStatus ||
      (args.verificationStatus as string) === "all"
    )
      return undefined;

    if (userContext?.companyId) {
      return await db
        .query("order_payments")
        .withIndex("by_company_and_status", (q) =>
          q
            .eq("internalControl.companyId", userContext.companyId!)
            .eq("verificationStatus", args.verificationStatus!),
        )
        .collect();
    }
  },
};
